export const TOOLTIPS = {
  username: "Your unique identifier for logging in. 4-20 characters, letters and numbers only.",
  password: "Must contain at least 8 characters, including one uppercase letter and one number.",
  apiKey: "Found in your account settings. Keep this secret!",
  darkMode: "Toggle between light and dark color schemes",
  documentReminderHelpBtn: `Send a friendly reminder email to the customer about remaining documents that are still needed. <br/> <br/> If a reminder has been sent recently, this button will be disabled.`,
  
  // template management
  requestDocumentTemplates: "Create or Select the document templates you want to request from customers or businesses.",

  // Add more tooltips as needed
}
  
export type TooltipKey = keyof typeof TOOLTIPS;